// Imports
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery as useApolloQuery, useMutation as useApolloMutation } from "@apollo/client";
import { useSite } from "../../contexts/siteContext";

export const onError = (setAuthenticated, isLazy = false) => (error) => {
    const unAuthenticated = !!error.graphQLErrors?.find(e => e.extensions.code?.toUpperCase() === "UNAUTHENTICATED");

    if (unAuthenticated) {
        setAuthenticated(false);
        // eslint-disable-next-line no-throw-literal
        throw null;
    } else {
        if (isLazy) return error;
        throw error;
    }
};

export const useQuery = (query, options = {}) => {
    const { getAccessTokenSilently } = useAuth0();
    const { setAuthenticated } = useSite();
    return useApolloQuery(query, {
        ...options,
        context: {
            ...(options.context || {}),
            getAccessTokenSilently,
        },
        onError: onError(setAuthenticated),
    });
}

export const useLazyQuery = (query, options = {}) => {
    const result = useQuery(query, { ...options, skip: true });
    const { refetch, client } = result;

    const lazyQuery = async (variables = {}) => {
        try {
            const data = client.readQuery({ query, variables });

            if (data === null) {
                return await refetch(variables);
            }

            return { data };
        } catch (e) {
            return await refetch(variables);
        }
    };

    return [lazyQuery, result];
}

export const useMutation = (mutation, options = {}) => {
    const { getAccessTokenSilently } = useAuth0();
    const { setAuthenticated } = useSite();
    return useApolloMutation(mutation, {
        ...options,
        context: {
            ...(options.context || {}),
            getAccessTokenSilently,
        },
        onError: onError(setAuthenticated),
    });
}
